import { defineComponent as i, createElementBlock as s, openBlock as a, createTextVNode as m, createVNode as l, unref as d } from "vue";
import { ScalarIconCaretDown as u } from "@scalar/icons";
import { useConfig as f } from "../hooks/useConfig.js";
import { useSidebar as p } from "../features/sidebar/hooks/useSidebar.js";
const h = /* @__PURE__ */ i({
  __name: "ShowMoreButton",
  props: {
    id: {}
  },
  setup(t) {
    const { setCollapsedSidebarItem: r } = p(), n = f(), c = () => {
      var o, e;
      r(t.id, !0), (e = (o = n.value).onShowMore) == null || e.call(o, t.id);
    };
    return (o, e) => (a(), s("button", {
      class: "show-more",
      type: "button",
      onClick: c
    }, [
      e[0] || (e[0] = m(" Show More ")),
      l(d(u), {
        weight: "bold",
        class: "text-c-2 mt-0.25 size-3"
      })
    ]));
  }
});
export {
  h as default
};
